import type { ColumnDef } from '@tanstack/react-table';

import { type GetTagsQuery, TagState } from 'data/__generated__';
import { textColumn, numberColumn, multiSelectColumn } from 'components/DataTable';

import { TagState as TagStateComponent } from 'pages/Tags/components/TagState';

export type TagRow = GetTagsQuery['tags'][number];

export type TagFilterInput = {
    searchValue?: string;
    state?: TagState[];
    name?: string;
    displayIndex?: number;
    type?: string;
};

export const tagsColumns: ColumnDef<TagRow, unknown>[] = [
    textColumn<TagRow, TagFilterInput>({
        accessorKey: 'name',
        header: 'Nom',
        filterKey: 'name',
        defaultVisible: true,
    }),
    textColumn<TagRow, TagFilterInput>({
        accessorKey: '_id',
        header: 'Identifiant unique',
        defaultVisible: false,
    }),
    numberColumn<TagRow, TagFilterInput>({
        accessorKey: 'displayIndex',
        header: "Index d'affichage",
        filterKey: 'displayIndex',
        defaultVisible: true,
    }),
    textColumn<TagRow, TagFilterInput>({
        accessorKey: 'type',
        header: 'Type',
        filterKey: 'type',
        defaultVisible: true,
    }),
    multiSelectColumn<TagRow, TagFilterInput>({
        accessorKey: 'state',
        header: 'Statut',
        filterKey: 'state',
        defaultVisible: true,
        options: Object.values(TagState).map((state) => ({ value: state, label: state })),
        renderOption: (option) => <TagStateComponent state={option.value as TagState} />,
        cell: ({ row }) => <TagStateComponent state={row.original.state} />,
    }),
];
